// extracted by mini-css-extract-plugin
export default {"card":"A1-z","carouselContainer":"B1-z","carouselContent":"C1-z"};